import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import mMessages from '../locales/menuMessages';
import { commonTranslate } from "../../../utils/commonUtilFunc";
var SubMenu = _Menu.SubMenu;
var MenuBar = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuBar, _React$Component);
  function MenuBar(props) {
    var _this;
    _classCallCheck(this, MenuBar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuBar).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToHead", function (e) {
      _this.setState({
        selectedKeys: e && e.key ? [e.key] : []
      });
      document.getElementById("main-header").scrollIntoView(true);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOpenChange", function (e) {
      _this.setState({
        openkeys: e
      });
    });
    _this.state = {
      menuInfo: _this.props.menuInfo,
      selectedKeys: _this.props.selectedKeys,
      openkeys: _this.props.openkeys
    };
    return _this;
  }
  _createClass(MenuBar, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (JSON.stringify(this.props.indexPage.menuInfo) !== "{}") {
        sessionStorage.setItem("menuInfo", JSON.stringify(this.props.indexPage.menuInfo));
        sessionStorage.setItem("role", this.props.indexPage.rolecname);
        sessionStorage.setItem("companyNm", this.props.indexPage.companyNm);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(this.props.menuInfo) !== JSON.stringify(nextProps.menuInfo) || JSON.stringify(this.props.selectedKeys) !== JSON.stringify(nextProps.selectedKeys)) {
        this.setState({
          menuInfo: nextProps.menuInfo,
          selectedKeys: nextProps.selectedKeys,
          openkeys: nextProps.openkeys
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var __ = commonTranslate(this);
      var menuItemList = [];
      var menuInfo = this.state.menuInfo;
      for (var key in menuInfo) {
        if (menuInfo[key].sub) {
          var subs = menuInfo[key].sub;
          var subMenuItemList = [];
          for (var subKey in subs) {
            subMenuItemList.push(/*#__PURE__*/React.createElement(_Menu.Item, {
              key: subs[subKey].id
            }, /*#__PURE__*/React.createElement(Link, {
              to: "/main/" + subs[subKey].path
            }, "\xA0\xA0\xA0\xA0", /*#__PURE__*/React.createElement("span", null, __(mMessages[subs[subKey].name])))));
          }
          menuItemList.push(/*#__PURE__*/React.createElement(SubMenu, {
            key: menuInfo[key].id,
            title: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Icon, {
              style: {
                fontSize: 16
              },
              type: menuInfo[key].icon
            }), /*#__PURE__*/React.createElement("span", null, __(mMessages[menuInfo[key].name])))
          }, subMenuItemList));
        } else {
          menuItemList.push(/*#__PURE__*/React.createElement(_Menu.Item, {
            key: menuInfo[key].id
          }, /*#__PURE__*/React.createElement(Link, {
            to: "/main/" + menuInfo[key].path
          }, /*#__PURE__*/React.createElement(_Icon, {
            style: {
              fontSize: 16
            },
            type: menuInfo[key].icon
          }), /*#__PURE__*/React.createElement("span", null, __(mMessages[menuInfo[key].name])))));
        }
      }
      return /*#__PURE__*/React.createElement(_Menu, {
        mode: "inline",
        key: "menu",
        style: {
          height: '100%'
        },
        inlineIndent: 24,
        selectedKeys: this.state.selectedKeys,
        onOpenChange: this.onOpenChange,
        openKeys: this.state.openkeys,
        inlineCollapsed: this.props.collapsed,
        onClick: this.scrollToHead,
        theme: this.props.theme
      }, menuItemList);
    }
  }]);
  return MenuBar;
}(React.Component);
function mapDispatchToProps(_ref) {
  var indexPage = _ref.indexPage;
  return {
    indexPage: indexPage
  };
}
export default connect(mapDispatchToProps)(injectIntl(MenuBar));